import { render, staticRenderFns } from "./commandDivider.vue?vue&type=template&id=36bcaaa6&scoped=true&"
var script = {}
import style0 from "./commandDivider.vue?vue&type=style&index=0&id=36bcaaa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcaaa6",
  null
  
)

export default component.exports